import { rootApi } from "src/services/api";
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./rootReducer";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // or use 'redux-persist/lib/localStorage' for localStorage

const middlewares = [rootApi.middleware];

const persistConfig = {
  key: "root", // a unique key to identify the root of your Redux store in local storage
  storage, // the storage engine to use (e.g., localStorage, sessionStorage)
  // Optionally, you can specify specific state slices to persist:
  // whitelist: ['slice1', 'slice2'],
  blacklist: [rootApi.reducerPath],
};

/* This code is configuring and creating a Redux store using the `configureStore` function from the
`@reduxjs/toolkit` library. */
const store = configureStore({
  reducer: persistReducer(persistConfig, rootReducer),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(middlewares),
  devTools: process.env.NODE_ENV !== "production",
});

export default store;
